export const AuthorityTypes = Object.freeze({
    POPE: 'pope',
    DIOCESE: 'diocese',
})

export const AuthorityTypeInfos = Object.freeze({
    POPE: {value: 'pope', label: 'pope'},
    DIOCESE: {value: 'diocese', label: 'diocese'},
})